var map = {
	"./test-chto-eto-znachit.json": 3406,
	"./test-chto-vy-znaete-ob-istorii-interneta.json": 7658,
	"./test-chto-vy-znayete-o-memakh.json": 1418,
	"./test-eto-normalno-ili-opasno.json": 4766,
	"./test-hey-chat-kak-dela-data.json": 4853,
	"./test-nub-guru-data.json": 9313,
	"./test-prilichnom-obshhestve-znaete-li-vy-setevoj-jetiket.json": 6250,
	"./test-vu-vse-pravilno-obyasnili.json": 156
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8499;